import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ba5dbc1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-wrapper" }
const _hoisted_2 = { class: "platform-name" }
const _hoisted_3 = { class: "user" }
const _hoisted_4 = { class: "dialog-footer" }

import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import defaultUserIcon from '@/assets/icons/icon-user-default.png'
import { oauthRemoveToken, passwordUpdate } from '@/api'
import type { FormInstance } from 'element-plus'
import { ElMessage } from 'element-plus'
import { encode } from '@/utils'
import { passwordReg } from '@/common/regexp'
import LanSwitch from '@/components/lan-switch'
import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const t = i18n.global.t

const dialogVisible = ref(false)
const router = useRouter()

const formData = ref({
  oldPassword: '',
  newPassword: '',
  confirmPassword: '',
})
const validator = (rule: any, value: any, callback: any) => {
  if (value !== formData.value.newPassword) {
    callback(t('LOGIN.pwdMsgMatch'))
  } else {
    callback()
  }
}

const rules = {
  oldPassword: [{ required: true, message: t('LOGIN.oldMsg') }],
  newPassword: [
    { required: true, message: t('LOGIN.newPwdPla') },
    {
      pattern: passwordReg,
      message: '6-30位字符',
    },
  ],
  confirmPassword: [
    { required: true, message: t('LOGIN.pwdAgain') },
    {
      validator,
    },
  ],
}

const dropdownList = [
  {
    command: 'updatePassword',
    label: t('LOGIN.updatePwd'),
  },
  {
    command: 'signOut',
    label: t('LOGIN.signOut'),
  },
]

const handleCommand = async (command: string) => {
  if (command === 'updatePassword') {
    dialogVisible.value = true
  } else if (command === 'signOut') {
    oauthRemoveToken({
      token: localStorage.getItem('Authorization'),
    }).finally(() => {
      router.push('/login')
      localStorage.removeItem('Authorization')
      localStorage.removeItem('AuthorizationUser')
    })
  }
}

const loading = ref(false)
const formRef: any = ref<FormInstance>()

const handleClose = () => {
  dialogVisible.value = false
  formRef.value.resetFields()
}

const handleUpdatePassword = () => {
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      const { oldPassword, newPassword } = formData.value
      loading.value = true

      const res: any = await passwordUpdate({
        oldPassword: encode(oldPassword),
        newPassword: encode(newPassword),
      }).finally(() => {
        loading.value = false
      })
      if (res?.code === 0) {
        ElMessage({
          message: t('LOGIN.updateSuccess'),
          type: 'success',
        })
        handleClose()
      } else if (res?.code === 20000) {
        ElMessage({
          message: t('LOGIN.oldPwdError'),
          type: 'error',
        })
      } else {
        ElMessage({
          message: res?.msg,
          type: 'error',
        })
      }
    }
  })
}

const userName = ref('')
onMounted(() => {
  userName.value = localStorage.getItem('AuthorizationUser') || ''
})

return (_ctx: any,_cache: any) => {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('COMMON.platformName')), 1),
      _createElementVNode("div", null, [
        _createVNode(_component_el_dropdown, { onCommand: handleCommand }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dropdownList, (item, index) => {
                  return _createVNode(_component_el_dropdown_item, {
                    key: index,
                    command: item.command
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["command"])
                }), 64))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_avatar, {
                size: 25,
                src: _unref(defaultUserIcon)
              }, null, 8, ["src"]),
              _createElementVNode("span", null, _toDisplayString(userName.value), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(LanSwitch))
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogVisible).value = $event)),
      title: _ctx.$t('LOGIN.updatePwdTitle'),
      width: "558px",
      "before-close": handleClose,
      "append-to-body": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_el_button, {
            plain: "",
            onClick: handleClose
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('LOGIN.btnCancel')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            loading: loading.value,
            type: "primary",
            onClick: handleUpdatePassword
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('LOGIN.btnYes')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          class: "form ws_mr15",
          "label-width": "120px",
          model: formData.value,
          rules: rules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "oldPassword",
              label: _ctx.$t('LOGIN.oldPwd')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.oldPassword,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.oldPassword) = $event)),
                  modelModifiers: { trim: true },
                  type: "password",
                  placeholder: _ctx.$t('LOGIN.oldPwdPla'),
                  maxlength: "50",
                  "show-password": ""
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "newPassword",
              label: _ctx.$t('LOGIN.newPwd')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.newPassword,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.newPassword) = $event)),
                  modelModifiers: { trim: true },
                  type: "password",
                  placeholder: _ctx.$t('LOGIN.newPasswordPla'),
                  maxlength: "50",
                  "show-password": ""
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "confirmPassword",
              label: _ctx.$t('LOGIN.confirmPwd')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.confirmPassword,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.confirmPassword) = $event)),
                  modelModifiers: { trim: true },
                  type: "password",
                  placeholder: _ctx.$t('LOGIN.confirmPwdPla'),
                  maxlength: "50",
                  "show-password": ""
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})